// import GoogleTagAdapter from './Adapters/GoogleTagAdapter';

/**
 * Logs errors on console and google analytics
 */
class ErrorLogging {
  /**
   * Setup console logging for Production Google Analytics
   */

  static setupProductionErrorLogging() {
    window.onerror = ErrorLogging.handleErrors.bind(this);
  }

  /**
   * Log errors to Google Analytics and print to console
   * @private
   * @type {boolean}
   */
  // static handleErrors(message, sourceURL, lineNumber, columnNumber, e) {
  static handleErrors(message) {
    const errorMessage = message.split(':') || ['Unknown Error', 'Unknown Message'];
    const errorType = errorMessage[0];

    ErrorLogging.consoleLog(errorType);

    // GoogleTagAdapter.track('error', {
    //   message,
    //   sourceURL,
    //   lineNumber,
    //   columnNumber,
    //   stack: e && e.stack,
    // });
  }

  /**
   * Log the message to the console. Add snowman easteregg
   * @private
   * @param {string} errorType
   */
  static consoleLog(errorType) {
    const logMessage = `This %c${errorType}%c has been logged.%c☃`;
    const errorStyle = 'color: #FF3333;';
    const snowmanStyle = 'font-size: 72px; color: #6699CC';

    console.log(logMessage, errorStyle, '', snowmanStyle); // eslint-disable-line no-console
  }
}

export default ErrorLogging;
